import { render, staticRenderFns } from "./ResetFzPwd.vue?vue&type=template&id=757e382e&scoped=true"
import script from "./ResetFzPwd.vue?vue&type=script&lang=js"
export * from "./ResetFzPwd.vue?vue&type=script&lang=js"
import style0 from "./ResetFzPwd.vue?vue&type=style&index=0&id=757e382e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757e382e",
  null
  
)

export default component.exports